var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-ideal 1",
    clipPath: "url(#clip0_307_7769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.32812 3.29656V32.2764H20.3893C31.6438 32.2764 36.5244 26.0348 36.5244 17.7581C36.5244 9.51358 31.6438 3.29656 20.3893 3.29656H3.32812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.17383 5.12442H20.3933C30.7231 5.12442 34.6826 10.7107 34.6826 17.7577C34.6826 26.2077 29.1534 30.4477 20.3933 30.4477H5.17383V5.12442ZM6.64927 6.58554V28.9874H20.3933C28.6911 28.9874 33.2058 25.1584 33.2058 17.7577C33.2058 10.1519 28.3117 6.58509 20.3933 6.58509H6.64927V6.58554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.49219 19.4051H12.8919V27.1596H8.49219V19.4051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6914 18.2057C12.2015 18.2057 13.4258 16.9934 13.4258 15.4979C13.4258 14.0024 12.2015 12.79 10.6914 12.79C9.18125 12.79 7.95703 14.0024 7.95703 15.4979C7.95703 16.9934 9.18125 18.2057 10.6914 18.2057Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.1193 16.7647V18.0203H18.9843V12.9817H22.0191V14.2369H20.2518V14.8202H21.923V16.0759H20.2518V16.7651L22.1193 16.7647ZM22.6677 18.0212L24.2018 12.9799H26.0052L27.5388 18.0212H26.2194L25.9317 17.0461H24.2735L23.9853 18.0212H22.6677ZM24.6452 15.7918H25.5627L25.1418 14.3678H25.0652L24.6452 15.7918ZM28.1762 12.9803H29.4446V16.7651H31.3219C30.8068 9.89774 25.3525 8.41383 20.3935 8.41383H15.1083V12.983H15.8905C17.3167 12.983 18.2022 13.9407 18.2022 15.4818C18.2022 17.072 17.3379 18.0212 15.8905 18.0212H15.1083V27.1632H20.3939C28.4527 27.1632 31.2592 23.4565 31.3584 18.0203H28.1762V12.9803ZM15.1074 14.2382V16.7651H15.8905C16.4331 16.7651 16.9347 16.6097 16.9347 15.4813C16.9347 14.3794 16.3767 14.2382 15.8905 14.2382H15.1074Z",
    fill: "#D50072"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_7769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.5556,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.269a23c7930f5ddb34473eb9f4e765b4.svg";
export { ForwardRef as ReactComponent };